import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

export interface PasswordPolicyDto {
  id: string;
  companyId: string;
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireNumber: boolean;
  requireSpecialChar: boolean;
  passwordExpiryDays: number;
  passwordHistoryCount: number;
  maxLoginAttempts: number;
  lockoutDurationMinutes: number;
  forceChangeOnFirstLogin: boolean;
  preventUsernameInPassword: boolean;
  sessionTimeoutMinutes: number;
  isActive: boolean;
}

export interface UpdatePasswordPolicyRequest {
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireNumber: boolean;
  requireSpecialChar: boolean;
  passwordExpiryDays: number;
  passwordHistoryCount: number;
  maxLoginAttempts: number;
  lockoutDurationMinutes: number;
  forceChangeOnFirstLogin: boolean;
  preventUsernameInPassword: boolean;
  sessionTimeoutMinutes: number;
}

export const passwordPolicyApi = {
  /** GET /api/v1/password-policies/current */
  getCurrent: () =>
    apiClient.get<ApiResponse<PasswordPolicyDto>>('/password-policies/current'),

  /** PUT /api/v1/password-policies */
  update: (data: UpdatePasswordPolicyRequest) =>
    apiClient.put<ApiResponse<PasswordPolicyDto>>('/password-policies', data),
};
